module.exports = __webpack_public_path__ + "img/v5.5a00b86e.png";